import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import Modal from '../../common/components/Modal';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Placeholder from '../../common/components/Placeholder';
import ExtensionReadme from '../models/ExtensionReadme';
export default class ReadmeModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "extName", void 0);
    _defineProperty(this, "readme", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    app.store.models['extension-readmes'] = ExtensionReadme;
    this.name = this.attrs.extension.id;
    this.extName = this.attrs.extension.extra['flarum-extension'].title;
    this.loading = true;
    this.loadReadme();
  }
  className() {
    return 'ReadmeModal Modal--large Modal--inverted';
  }
  title() {
    return app.translator.trans('core.admin.extension.readme.title', {
      extName: this.extName
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.loading ? m("div", {
      className: "ReadmeModal-loading"
    }, m(LoadingIndicator, null)) : m("div", null, this.readme.content() ? m.trust(this.readme.content()) : m(Placeholder, {
      text: app.translator.trans('core.admin.extension.readme.no_readme')
    })));
  }
  async loadReadme() {
    this.readme = await app.store.find('extension-readmes', this.name);
    this.loading = false;
    m.redraw();
  }
}
flarum.reg.add('core', 'admin/components/ReadmeModal', ReadmeModal);